<div class="content">
  <div class="content-space" (click)="showTooltip()">
    <ng-content></ng-content>
  </div>
  <div class="tooltip" [ngClass]="arrow" [class.d-none]="!displayTooltip">
    {{ content }}
  </div>
</div>
